<template>
  <div class="welcome-page container">
    <div class="row justify-content-center">
      <div class="col-11 col-lg-9">
        <div class="pb-5 pb-md-0">
          <div class="container">
            <div class="row">
              <div class="col">
                <h3 class="title text-white text-center">Bienvenido a ZET</h3>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-8 col-lg-9">
                <WelcomeForm/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import WelcomeForm from "../Components/WelcomeForm";

export default {
  components: {
    WelcomeForm
  }
}
</script>

<style lang="stylus" scoped>
@import '../Styles/welcome-page';
</style>
